// extracted by mini-css-extract-plugin
module.exports = {"duration":"timeSlotModal_duration__2KxiR","assignSlot":"timeSlotModal_assignSlot__3zaHZ"};